import uploadHelper from './upload-helper'
import { Message } from 'element-ui'

const namespaced = true

const state = {
  downloadFiles: [],
  uploadFiles: []
}

const getters = {
  downloadFiles: state => state.downloadFiles,
  uploadFiles: state => state.uploadFiles
}

const actions = {
  pushFileDownload ({ commit }, file) {
    commit('pushFileDownload', file)
  },
  pushFileUpload ({ commit, dispatch }, { file, parentItemId }) {
    const type = uploadHelper.protoFileType(file.type)
    dispatch('files/createFilePromise', { file, type, parentItemId }, { root: true })
      .then(({ presignedUrl, item, file }) => {
        item.presignedUrl = presignedUrl
        item.file = file
        commit('pushFileUpload', item)
      }).catch(() => {
        Message({
          type: 'error',
          message: `Oops, it looks like you don't have enough space left`,
          showClose: true
        })
      })
  },
  removeFileDownloadById ({ commit }, fileId) {
    commit('removeFileDownloadById', fileId)
  },
  removeFileUploadById ({ commit }, fileId) {
    commit('removeFileUploadById', fileId)
  }
}

const mutations = {
  pushFileDownload (state, file) {
    const index = state.downloadFiles.findIndex(f => {
      return f.id === file.id
    })

    if (index === -1) {
      state.downloadFiles.push(file)
    }
  },
  pushFileUpload (state, file) {
    state.uploadFiles.push(file)
  },
  removeFileDownloadById (state, fileId) {
    const index = state.downloadFiles.findIndex(f => {
      return f.id === fileId
    })

    if (index > -1) {
      state.downloadFiles.splice(index, 1)
    }
  },
  removeFileUploadById (state, fileId) {
    const index = state.uploadFiles.findIndex(f => {
      return f.id === fileId
    })

    if (index > -1) {
      state.uploadFiles.splice(index, 1)
    }
  }
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
